import * as angular from "angular";
import template from "./index.html";
import "./index.less";
import jsonSchemaForm from "../../../extensions/json-schema/json-schema-form";

export function controller() {
	const ctrl = this;

	ctrl.$onInit = () => {
		const request = ctrl.resolve.request;
		const statusNames = {
			PENDING: "Pending",
			PROCESSED: "Processed",
			REJECTED: "Rejected"
		};

		ctrl.schema = ctrl.resolve.schema;
		ctrl.model = angular.copy(request.Data || {});
		ctrl.options = {
			readonly: true
		};
		ctrl.status = request.Status?.Name
			|| statusNames[request.Status?.Code]
			|| ((request.IsProcessed ?? request.Status?.IsProcessed) ? "Processed" : "Pending");
		ctrl.comment = request.Comment;
	};

	ctrl.handleClose = () => {
		ctrl.modalInstance.dismiss();
	};
}

export default angular
	.module("vesl.screens.welcome.form-request-modal", [jsonSchemaForm])
	.component("welcomeFormRequestModal", {
		controller,
		template,
		bindings: {
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
